import store from '../../store';
import api from '../../services/api';
import { Creators } from '../ducks/product';
import { call, put } from 'redux-saga/effects';
import { getChatbotDataPrepared } from './chatbot';


export function* getProducts({ filter, props }) {
  try {
    let response;
    const chatbotData = yield getChatbotDataPrepared({ props });

    yield put(Creators.productRequest());
    response = yield call(api.post, 'public/chatbot', { filter: { ...filter, ...chatbotData }, action: 'get-products' });

    if (response.data && response.data.length) {
      props.triggerNextStep({ trigger: props.trigger });
    } else {
      props.triggerNextStep({ trigger: props.triggerFallback });
    }


    yield put(Creators.productSuccess(response.data));
  } catch (err) {
    yield put(Creators.productError({ err }));
  }
}

export function* sendEmailProducts({ props }) {
  try {
    const products = store.getState().product.data;
    const data = yield getChatbotDataPrepared({ props });

    yield put(Creators.productRequest());
    yield call(api.post, 'public/chatbot', { data, action: 'send-mail' });

    props.triggerNextStep({ trigger: props.trigger });

    yield put(Creators.productSuccess(products));
  } catch (err) {
    yield put(Creators.productError({ err }));
  }
}